<script>
import { VueRenderer } from '@tiptap/vue-3';
import tippy from 'tippy.js';
import MentionDropdownList from './MentionDropdownList.vue';

export default {
  items: async ({ editor, query }) => {
    const employees = await editor.contentComponent.parent.ctx.fetchMentionableEmployees();
    return employees
      .map((employee) => {
        const result = {
          label: employee.attributes.name,
          id: employee.id,
        };
        return result;
      })
      .filter((item) => item.label.toLowerCase().includes(query.toLowerCase()));
  },

  render() {
    let component;
    let popup;

    return {
      onStart: (props) => {
        component = new VueRenderer(MentionDropdownList, {
          props,
          editor: props.editor,
        });

        if (!props.clientRect) {
          return;
        }

        const editor = document.getElementById('note_editor');

        popup = tippy(editor, {
          getReferenceClientRect: props.clientRect,
          content: component.element,
          showOnCreate: true,
          interactive: true,
          trigger: 'manual',
          placement: 'right',
        });
      },

      onUpdate(props) {
        component.updateProps(props);

        if (popup) {
          popup.setProps({
            getReferenceClientRect: props.clientRect,
          });
        }
      },

      onKeyDown(props) {
        if (props.event.key === 'Escape') {
          popup.hide();
          return true;
        }

        if (component.ref) {
          return component.ref.onKeyDown(props);
        }

        return false;
      },

      onExit() {
        if (popup) {
          popup.destroy();
        }
        if (component) {
          component.destroy();
        }
      },
    };
  },
};
</script>
